import styled, { css } from 'styled-components'

import ArrowRightIcon from '../../images/icons/arrow-right.svg'
import Button from '../Button/Button'

import { deviceMax } from '../../theme/breakpoints'
import pxToRem from '../../utils/pxToRem'
import { LOGO_WIDTH } from '../../theme/constants'

export const StyledBreadcrumbs = styled.ol`
  align-items: center;
  display: flex;
  margin-left: ${pxToRem(LOGO_WIDTH.desktop)};
  padding-left: ${pxToRem(20)};
  background-color: ${({ theme }) => theme.colors.unique.white};
  @media ${deviceMax.laptop} {
    margin-left: ${pxToRem(LOGO_WIDTH.laptop)};
  }
  @media ${deviceMax.tablet} {
    margin-left: ${pxToRem(LOGO_WIDTH.tablet)};
  }
  @media ${deviceMax.mobileL} {
    display: none;
  }
`

export const StyledContainer = styled.li`
  align-items: center;
  display: flex;
  margin: ${pxToRem(7)} ${pxToRem(17.5)} ${pxToRem(7)} ${pxToRem(0)};
`

export const StyledBreadcrumbsLink = styled(Button)`
  margin: ${({ isHome }) =>
    isHome
      ? `${pxToRem(7)} ${pxToRem(17.5)} ${pxToRem(7)} ${pxToRem(0)}`
      : '0'};
  padding: initial;
  font-size: ${({ theme }) => theme.fonts.sizes.base};
  line-height: ${({ theme }) => theme.fonts.lineHeight.base};
  font-weight: ${({ theme }) => theme.fonts.weight.normal};
`

const StyledBreadcrumbsText = css`
  font-size: ${({ theme }) => theme.fonts.sizes.base};
  line-height: ${({ theme }) => theme.fonts.lineHeight.base};
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
`

export const StyledBreadcrumbsSeparator = styled(ArrowRightIcon)`
  ${StyledBreadcrumbsText}
  margin-right: ${pxToRem(17.5)};
  width: ${pxToRem(5)};
  height: ${pxToRem(8.75)};
`

export const StyledBreadcrumbsCurrent = styled.p`
  ${StyledBreadcrumbsText}
`
